import React from 'react';
import {observer} from 'mobx-react';
import {auth, t} from 'shared/core';
import {Modal, ModalButtons} from 'components/modals';
import {CheckboxWithLabel, CheckboxWithChildren} from 'components';
import {FormattedMessage} from 'react-intl';

const CancelSubscriptionModal = observer(({uiState}) => {
  return (
    <Modal
      size='sm'
      isOpen={uiState.cancelSubscriptionModalOpen}
      onHide={() => uiState.closeCancelSubscriptionModal()}
      title='company_settings.billing.cancel_subscription.Cancel Subscription'
    >
      <div className='pb2'>
        <FormattedMessage id="company_settings.billing.cancel_subscription.cancel_subscription_modal.Cancelling your subscription is immediate and will disable access to Collage for all users, including yourself."/>
      </div>
      <div className='pb2'>
        {auth.company.benefitsEnabled && <FormattedMessage id="company_settings.billing.cancel_subscription.cancel_subscription_modal.Cancelling will also end synchronization of benefit updates."/>}
      </div>
      <div className='pb3'>
        <FormattedMessage id="company_settings.billing.cancel_subscription.cancel_subscription_modal.This should only be done when you are ready to stop using Collage."/>
      </div>
      <div className='medium pb1'>
        <FormattedMessage id='company_settings.billing.cancel_subscription.cancel_subscription_modal.Confirm the items below to proceed:' />
      </div>
      <CheckboxWithLabel
        label='company_settings.billing.cancel_subscription.cancel_subscription_modal.My employees are no longer using Collage.'
        checked={uiState.confirmNotUsingCollage}
        onChange={e => uiState.toggleConfirmNotUsingCollage()}
      />
      {auth.company.benefitsEnabled &&
        <CheckboxWithLabel
        label='company_settings.billing.cancel_subscription.cancel_subscription_modal.Collage no longer needs to sync benefits updates.'
        checked={uiState.confirmNoBenefitUpdates}
        onChange={e => uiState.toggleConfirmNoBenefitUpdates()}
      />}
      <CheckboxWithChildren
        checked={uiState.confirmDataExported}
        onChange={e => uiState.toggleConfirmDataExported()}
      >
        <a target='_blank' href={t('company_settings.billing.cancel_subscription.cancel_subscription_modal.SUPPORT_LINK')}>
          <FormattedMessage id='company_settings.billing.cancel_subscription.cancel_subscription_modal.I have read the offboarding support article and have exported all of the data I need.'/>
        </a>
      </CheckboxWithChildren>
      <ModalButtons
        onSave={() => uiState.cancelSubscription()}
        saveCaption='company_settings.billing.cancel_subscription.cancel_subscription_modal.Confirm and Cancel Subscription'
        trait='destructive'
        saveEnabled={uiState.enableCancelSubscription}
        onCancel={() => uiState.closeCancelSubscriptionModal()}
      />
    </Modal>
  );
});

export default CancelSubscriptionModal;
